// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"92b21e37","1395":"92b21e37","5309":"92b21e37","5469":"92b21e37","5609":"92b21e37","5617":"92b21e37","7107":"92b21e37","8028":"92b21e37","8190":"92b21e37","9591":"92b21e37"}[chunkId] + ".chunk.css";
};